<footer class="footer-section py-3 px-3 bg-light">
  <div class="container-fluid">
    <div class="d-flex justify-content-between ">
      <div class="d-flex gap-2">
        <span> &copy; 2026</span>
        <span>AGRIFY.AI <i class="bi bi-dot"></i> <span>{{this.user.roles[0].split('_')[0]}} PORTAL</span></span>
        <span>v2.0.0</span>

      </div>
      <div class="d-flex gap-4">
        <a href="/pdfs/T&C.pdf" target="_blank"
          style="cursor: pointer; text-decoration: none; color: #9CA3AF;">Terms of Service </a>
        <a href="/pdfs/Privacy Policy.pdf" target="_blank"
          style="cursor: pointer; text-decoration: none; color: #9CA3AF;">Privacy Policy</a>
        <span style="cursor: pointer;" (click)="viewHelp()">Help Center</span>


      </div>
    </div>
  </div>
</footer>